// The FOOTER of a home widget (HOME_WIDGETS_SPEC.md §2): the house mono
// micro-label (AppMicroLabel: `Code`, `Y`, uppercase by CSS, 0.06em,
// `inactive`) pinned to the bottom edge — "LAST 7 DAYS", "3 OVERDUE".
//
//   HomeWidgetFooter: { text: '{{ apps.widget.biRevenue.footer | polyglot }}' }
export const HomeWidgetFooter = {
  extends: 'AppMicroLabel',
  class: 'home-widget-footer',
  gridArea: 'footer',
  alignSelf: 'end',
  justifySelf: 'start',
  maxWidth: '100%',
  overflow: 'hidden',
  // secondary text: an ellipsis only with the full label in `title`
  textOverflow: 'ellipsis',
  title: (el) => el.call('homeSlotText', el) || null
}
